import React from "react";
import "./style.css";

const TermsConditions = () => {
  return (
    <div>
      <div className="row"></div>
      <div className="introduction">
        <p className="para-text">
          Welcome to Rajavruksha Realtors Pvt. Ltd. By accessing or using our
          website and services, you agree to comply with and be bound by the
          following Terms and Conditions. Please read them carefully before
          using our services.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading">1. Acceptance of Terms</p>
        <p className="para-text">
          By accessing and using our website and services, you agree to comply
          with these Terms and Conditions. If you do not agree with these Terms,
          you must refrain from using our website and services.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading">2. Definitions</p>
        <ul className="list-methods">
          <li className="list-text privacy-points">
            "Services" refers to the real estate services provided by
            Rajavruksha Realtors Pvt. Ltd., including property listings,
            consultation, transactions, and any related activities.
          </li>
          <li className="list-text privacy-points">
            "User" refers to any individual or entity accessing or using our
            website or services.
          </li>
          <li className="list-text privacy-points">
            "Website" refers to the official website of Rajavruksha Realtors
            Pvt. Ltd. and all associated platforms.
          </li>
        </ul>
      </div>
      <div className="introduction">
        <p className="para-heading">3. Use of Services</p>
        <p className="para-text">
          <span>Eligibility:</span> You must be at least 18 years old and
          legally capable of entering into binding contracts to use our
          services.
        </p>
        <p className="para-text">
          <span>Compliance:</span> You agree to use our website and services
          only for lawful purposes and in compliance with all applicable local,
          state, and national laws.
        </p>
        <p className="para-text">
          <span>Prohibited Use:</span>You agree not to misuse our website or
          services, including but not limited to, engaging in fraudulent
          activities, distributing harmful software, or interfering with the
          operation of our website.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading">4. Property Listings and Transactions</p>
        <p className="para-text">
          <span>Accuracy of Listings:</span> While we make every effort to
          provide accurate and up-to-date property listings, we do not guarantee
          the accuracy, completeness, or availability of the information
          provided.
        </p>
        <p className="para-text">
          <span>Third-Party Transactions:</span> Any transactions involving the
          purchase, sale, or lease of farm land are directly between you and the
          respective parties involved. Rajavruksha Realtors Pvt. Ltd. is not a
          party to these transactions and does not assume any responsibility or
          liability for such activities.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading"> 5. Fees and Payments</p>
        <p className="para-text">
          <span>Charges:</span> Certain services may incur fees, which will be
          communicated to you prior to the finalization of any transaction.
        </p>
        <p className="para-text">
          <span>Payment Methods:</span> Payments for services should be made
          through the methods specified on papers. You are responsible for
          ensuring timely and full payment for services rendered.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading"> 6. Limitation of Liability</p>
        <p className="para-text">
          To the fullest extent permitted by law, Rajavruksha Realtors Pvt. Ltd.
          shall not be liable for any direct, indirect, incidental, special, or
          consequential damages arising from your use of the website or
          services. This includes, but is not limited to, any loss of data,
          revenue, or goodwill.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading"> 7. Privacy and Data Protection</p>
        <p className="para-text">
          Your use of our services is subject to our Privacy Policy. By using
          our services, you consent to the collection, use, and sharing of your
          information as outlined in our Privacy Policy.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading"> 8. Termination</p>
        <p className="para-text">
          We reserve the right to terminate or suspend your access to our
          website or services at our discretion, without notice, if you violate
          any of these Terms or engage in unlawful activities.
        </p>
      </div>
      <div className="introduction">
        <p className="para-heading"> 9. Amendments to Terms</p>
        <p className="para-text">
          We reserve the right to modify these Terms and Conditions at any time.
          Any changes will be posted on this page, and the updated date will be
          indicated at the top. You are encouraged to review these Terms
          periodically.
        </p>
      </div>{" "}
      <div className="introduction">
        <p className="para-heading"> 10. Governing Law</p>
        <p className="para-text">
          These Terms and Conditions shall be governed by and construed in
          accordance with the laws of India. Any disputes shall be subject to
          the exclusive jurisdiction of the courts located in [City/Region].
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
